import React, { useMemo } from 'react';
import Icon from '../../../components/AppIcon';

const ValueAlertCard = ({ update }) => {
  const timeAgo = React.useMemo(() => {
    const now = new Date();
    const updateTime = new Date(update?.timestamp);
    const diffMs = now - updateTime;
    const diffSecs = Math.floor(diffMs / 1000);
    const diffMins = Math.floor(diffSecs / 60);
    
    if (diffSecs < 60) return `${diffSecs}s ago`;
    if (diffMins < 60) return `${diffMins}m ago`;
    return `${Math.floor(diffMins / 60)}h ago`;
  }, [update?.timestamp]);

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-success animate-pulse" />
          <span className="text-xs font-medium text-success">Live Update</span>
        </div>
        <span className="text-xs text-muted-foreground">{timeAgo}</span>
      </div>

      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="TrendingUp" size={20} className="text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-foreground truncate">Market Value Update</p>
          <p className="text-xs text-muted-foreground">Player ID: {update?.playerId?.slice(0, 8)}...</p>
        </div>
      </div>

      <div className="bg-muted/50 rounded-lg p-3">
        <span className="text-xs text-muted-foreground">New Valuation</span>
        <p className="text-lg font-bold text-foreground">€{(update?.marketValue / 1000000)?.toFixed(2)}M</p>
        <span className="text-xs text-muted-foreground">{new Date(update?.valuationDate)?.toLocaleDateString()}</span>
      </div>
    </div>
  );
};

export default ValueAlertCard;